<template>
  <div class="config-form-content weeduc-admin-config adminWeeducConfig weflix-admin-layoutLayout" v-if="hasReady">
    <div class="row g-3 g-lg-4 weeduc-admin-config-layout mx-0">
      <div class="col-12 col-lg-6 weeduc-admin-config-col">
        <div class="weeduc-admin-config-section">
          <h3 class="weeduc-admin-config-section-title">Cor do template</h3>
          <p class="weeduc-admin-config-section-lead">Cor principal dos botões e destaques do site.</p>
          <div class="form-group">
            <label class="form-label" for="weflixLayoutColor">Cor</label>
            <div class="weflix-color-row">
              <input id="weflixLayoutColorPicker" type="color" v-model="color" />
              <input id="weflixLayoutColor" type="text" class="form-input" v-model="color" placeholder="#000000" />
            </div>
          </div>
          <div class="form-group">
            <label class="form-label">Sugestões</label>
            <div class="weflix-color-swatches">
              <button type="button" v-for="swatch in suggestedColors" :key="swatch" :style="{ backgroundColor: swatch }" :aria-label="swatch" @click="setColor(swatch)"></button>
            </div>
          </div>
          <div class="form-group">
            <label class="form-label">Exemplo</label>
            <button type="button" class="weflix-color-sample" :style="{ backgroundColor: color }">Botão de exemplo</button>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-6 weeduc-admin-config-col">
        <div class="weeduc-admin-config-section">
          <h3 class="weeduc-admin-config-section-title">Banner principal</h3>
          <p class="weeduc-admin-config-section-lead">Para maior qualidade, use uma imagem maior que 1980x768 pixels.</p>
          <div class="form-group">
            <div class="form-file weeduc-admin-file-zone">
              <div class="file-wrapper primary weeduc-admin-file-wrapper">
                <img
                  :src="bannerPreview ? bannerPreview : banner"
                  alt="Banner principal"
                  v-show="bannerPreview || banner"
                  class="weflix-banner-preview"
                />
                <span class="thumbnail" v-if="!bannerPreview && !banner">
                  <span class="text" v-if="loaderImage">Clique aqui para selecionar a imagem</span>
                  <LoaderImage :hasReady="loaderImage"/>
                </span>
                <input
                  class="form-control weeduc-admin-file-input"
                  type="file"
                  @change="updateFilePathBanner"
                  accept=".png, .jpg, .jpeg, .webp"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="buttons-container weeduc-admin-site-form-actions">
      <div class="button d-flex flex-wrap gap-2 justify-content-end">
        <button type="button" class="btn btn-block btn-content" @click="update" :disabled="!loaderImage">Salvar</button>
        <button type="button" class="btn btn-block btn-content" @click="clearCache">Limpar cache</button>
      </div>
    </div>
  </div>
  <Loader :hasReady="hasReady"/>
</template>
<script>
import websiteApi from '@/utils/Weflix/website';
import contentApi from '@/utils/Weflix/content';
import { mapState, mapActions } from 'vuex';
import Loader from '@/components/Weflix/Loader.vue';
import apiAWS from '@/utils/storage/aws';
import LoaderImage from '@/components/Weflix/LoaderImage';
import { toast } from 'vue3-toastify';

export default {
  data(){
      return{
          color: '#ffffff',
          name: '',
          description: '',
          logo: '',
          favicon: '',
          logoPreview: '',
          faviconPreview: '',
          banner: '',
          bannerPreview: '',
          id: '',
          contents: [],
          hasReady: false,
          activeTheme: '',      
          descriptionAbout:'',
          facebook: '',
          gads: '',
          ganalytic: '',
          tagManager: '',
          rdrefreshToken: '',
          rdcode: '',
          rdSecret: '',
          rdClient: '',
          loaderImage: true,
          messageStatusCache: false
      }
  },
  components: {
      Loader,
      LoaderImage,
  },
  computed: {
    ...mapState(['token', 'layoutWebsite']),
    suggestedColors() {
      return [
        '#1AB490', '#28C565', '#2E8DD6', '#904EAC', '#B93126', '#E54236',
        '#E47220', '#EFBC11', '#FF69B4', '#800080', '#4B0082', '#008080',
        '#006400', '#8B4513', '#4682B4', '#FF4500', '#FFD700', '#00CED1',
      ];
    },
  },
  methods:{
    ...mapActions(['storeLayoutWebsite']),
    fillPreviewData() {
      const blank = (value) => value == null || String(value).trim() === '' || value === '#ffffff';
      if (blank(this.color)) this.color = '#4682B4';
      if (!this.bannerPreview && !this.banner) {
        const canvas = document.createElement('canvas');
        canvas.width = 1280;
        canvas.height = 480;
        const ctx = canvas.getContext('2d');
        const gradient = ctx.createLinearGradient(0, 0, 1280, 480);
        gradient.addColorStop(0, '#250891');
        gradient.addColorStop(1, '#4682B4');
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, 1280, 480);
        ctx.fillStyle = '#ffffff';
        ctx.font = 'bold 64px sans-serif';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('BANNER PRINCIPAL', 640, 240);
        this.bannerPreview = canvas.toDataURL('image/png');
      }
    },
    applyLayoutFields(layout) {
      const l = layout || {};
      this.id = l.id || '';
      this.name = l.nome || '';
      this.description = l.description || '';
      this.logo = l.logo || '';
      this.logoPreview = l.logoFinal || '';
      this.favicon = l.favicon || '';
      this.faviconPreview = l.faviconFinal || '';
      this.url = l.url || '';
      this.status = l.status || '';
      this.color = l.color || this.color || '#ffffff';
      this.activeTheme = l.typeLayout || '';
      this.descriptionAbout = l.about || '';

      this.facebook = l.facebookPixelCode || '';
      this.gads = l.googleAdsCode || '';
      this.ganalytic = l.googleAnalyticsCode || '';
      this.tagManager = l.tagManagerCode || '';
      this.rdrefreshToken = l.rdrefreshToken || '';
      this.rdcode = l.rdcode || '';
      this.rdSecret = l.rdsecretClient || '';
      this.rdClient = l.rdclienteId || '';
    },
    async syncWebsiteFromApi() {
      const fresh = await websiteApi.getWebsite(this.token);
      await this.storeLayoutWebsite({ layoutWebsite: fresh });
      this.applyLayoutFields(fresh);
    },
    async update() {
      this.hasReady = false;
      try {
        await this.updateContent();
        await this.updateWebsite();
        this.notify('Layout atualizado com sucesso!', 'success');
      } catch (error) {
        console.error('Erro ao salvar layout:', error);
        this.notify('Erro ao salvar layout.', 'error');
      } finally {
        this.hasReady = true;
      }
    },
     setColor(color){
        this.color = color;
     },
     getWebsite() {
      this.applyLayoutFields(this.layoutWebsite || {});
      this.hasReady = true;
    },
    async updateWebsite() {
      const current = this.layoutWebsite || {};
      const payload = {
        ...current,
        color: this.color,
        logo: current.logo,
        favicon: current.favicon,
        logoFinal: current.logoFinal,
        faviconFinal: current.faviconFinal,
      };
      await websiteApi.editWebsite(this.token, this.id || current.id, payload);
      await this.syncWebsiteFromApi();
    },
    async getContents(){
      try {
        const response = await contentApi.getContents(this.token);
        this.contents = response;
        if(this.contents.length > 0){
          this.banner = this.contents[0].pathImage;
          this.bannerPreview = this.contents[0].pathImageFinal;
        }
       
      } catch (error) {
        console.error('Erro ao obter dados do content:', error);
      }
    },
    async updateContent(){
      const payloadPost = [
        {
          "type": 1,
          "pathImage": this.banner,
          "order": 1,
          "status": 1
        }
      ];
      const payloadEdit = [{
        "id": this.contents && this.contents.length > 0 ? this.contents[0].id : null,
        "type": 1,
        "pathImage": this.banner,
        "order": 1,
        "status": 1
      }];

      if(!this.contents || this.contents.length == 0){
        await contentApi.createContent(this.token, payloadPost);
      }else{
        await contentApi.editContent(this.token, payloadEdit);
      }
      await this.getContents();
    },
    async putFileAws(url, file){
      try {
          const response = await apiAWS.putFileAWS(url, file);
      } catch (error) {
          console.error('Erro ao enviar arquivo para AWS');
      }
    },
    async updateFilePathBanner(event){
      this.loaderImage = false;
        const file = event.target.files[0];
        this.bannerPreview = URL.createObjectURL(file);
        try {
            const response =  await apiAWS.getSignatureImage(this.token, file.name);
            this.putFileAws(response.url, file);
            this.banner = response.token;
            console.debug(response);
            this.loaderImage = true;
        } catch (error) {
            console.error('Erro na geração do TOKEN AWS')
        }
    },
    async clearCache(){
      try {
        const response = await websiteApi.clearCache(this.token);
        this.messageStatusCache = true;
        this.notify('Cache do site limpo!', 'success');
      } catch (error) {
        this.notify('Erro ao limpar cache do site.', 'error');
        console.error('Erro ao limpar cache', error);
      }
    },
    notify(message, type = "info") {
            toast(message, {
                autoClose: 3000,
                position: 'top-right',
                theme: "light", 
                limit: 1,
                type: type,
                dangerouslyHTMLString: true
            });
        },
  },
  created() {
    this.getWebsite();
    this.getContents();
  }
}
</script>
<style scoped>
@import '@/css/weeduc/admin/config.css';

.weflix-color-row {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.weflix-color-row input[type="color"] {
  width: 48px;
  height: 42px;
  padding: 0;
  border: 1px solid #e0e2e8;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
}

.weflix-color-swatches {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.weflix-color-swatches button {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  cursor: pointer;
}

.weflix-color-sample {
  border: none;
  color: #fff;
  padding: 0.65rem 1.25rem;
  border-radius: 10px;
  font-weight: 700;
}

.weflix-banner-preview {
  width: 100%;
  max-height: 180px;
  object-fit: cover;
  border-radius: 8px;
}

.btn-content:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}
</style>
